import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ThemeService } from "src/app/shared/themes/theme.service";


@Component({
  selector: "app-chat-gpt",
  templateUrl: "./chat-gpt.component.html",
  styleUrls: ["./chat-gpt.component.scss"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => ChatGptComponent)
  }]
})
export class ChatGptComponent implements ControlValueAccessor {
  @Input() chatGPTAutocomplete?: string;
  @Input() chatGPTClass?: string;
  @Input() chatGPTDisabled?: boolean;
  @Input() chatGPTFormControlName?: string;
  @Input() chatGPTFormGroup!: UntypedFormGroup;
  @Input() chatGPTFormGroupClass?: string;
  @Input() chatGPTId?: string;
  @Input() chatGPTIcon?: string;
  @Input() chatGPTLabel?: string;
  @Input() chatGPTLabelIcon?: string;
  @Input() chatGPTLabelType?: string;
  @Input() chatGPTLabelTooltip?: string;
  @Input() chatGPTLabelTooltipPlacement?: string;
  @Input() chatGPTLengthValidator?: {
    count: 0;
    limit: 0;
    isOverLimit: false;
  };
  @Input() chatGPTMax?: number;
  @Input() chatGPTMaxLength?: number;
  @Input() chatGPTMin?: number;
  @Input() chatGPTName?: string;
  @Input() chatGPTNgClass?: string;
  @Input() chatGPTOptions?: any;
  @Input() chatGPTPlaceholder?: string;
  @Input() chatGPTPrefix?: string;
  @Input() chatGPTReadonly?: boolean;
  @Input() chatGPTRequired?: boolean;
  @Input() chatGPTSuffix?: string;
  @Input() chatGPTTooltip?: string;
  @Input() chatGPTValue?: any;
  @Input() chatGPTType: string = "base";
  @Input() aiChat: boolean;
  @Output() chatGPTValueChange = new EventEmitter<any>();
  @Output() chatGPTButtonClicked = new EventEmitter<any>();

  currentImage: string;
  tema: string;


  constructor(
    public translate: TranslateService,
    private themeService: ThemeService
  ) {
    this.tema = this.themeService.getActiveTheme().name;
    this.updateImageBasedOnTheme();
  }

  updateImageBasedOnTheme() {
    this.currentImage =
      this.tema === "Dark"
        ? "assets/img/icons/common/milvus_openai_chat_dark.png" // Imagem para o modo Dark
        : "assets/img/icons/common/milvus_openai_chat.png"; // Imagem para o modo Light
  }

  writeValue(obj: any): void {
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onFormChange(formValue: any, formName: string) {
    if (formValue && formName) {
      let emitter = {
        formValue: formValue.value,
        formName: formName,
      };
      this.chatGPTFormGroup.controls[formName].setValue(formValue.value);
      this.chatGPTValueChange.emit(emitter);
    }
  }

  onButtonClick() {
    if (this.chatGPTFormGroup.controls[this.chatGPTFormControlName].value) {
      this.chatGPTButtonClicked.emit(true);
    } else {
      this.chatGPTButtonClicked.emit(false);
    }
  }
}
